import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND}/api`;
export const TOKEN_KEY = "dt_token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resolve stored image paths (relative /api/files/... or absolute http URLs)
export const imgUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("http")) return u;
  return `${BACKEND}${u}`;
};

// ---- public ----
export const fetchCategories = async () => (await api.get("/categories")).data;
export const fetchProducts = async (category) =>
  (await api.get("/products", { params: category && category !== "all" ? { category } : {} })).data;
export const fetchProduct = async (id) => (await api.get(`/products/${id}`)).data;
export const submitQuote = async (payload) => (await api.post("/quotes", payload)).data;

// ---- auth ----
export const loginRequest = async (email, password) =>
  (await api.post("/auth/login", { email, password })).data;
export const getMe = async () => (await api.get("/auth/me")).data;

// ---- admin ----
export const adminProducts = async () => (await api.get("/admin/products")).data;
export const createProduct = async (p) => (await api.post("/admin/products", p)).data;
export const updateProduct = async (id, p) => (await api.put(`/admin/products/${id}`, p)).data;
export const deleteProduct = async (id) => (await api.delete(`/admin/products/${id}`)).data;
export const createCategory = async (c) => (await api.post("/admin/categories", c)).data;
export const updateCategory = async (id, c) => (await api.put(`/admin/categories/${id}`, c)).data;
export const deleteCategory = async (id) => (await api.delete(`/admin/categories/${id}`)).data;
export const adminQuotes = async () => (await api.get("/admin/quotes")).data;

export const uploadImage = async (file, onProgress) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/admin/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => onProgress && onProgress(Math.round((e.loaded * 100) / (e.total || 1))),
  });
  return data; // { url, path }
};
